<template>
  <v-flex fill-height lg12 md12>
    <v-card class="fill-height">
      <v-toolbar color="secondary" dense>
        <v-toolbar-title class="primarytext--text">Le note da confermare</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items class="primarytext--text justify-center align-center hidden-sm-and-down">
          <span class="ml-2">
            <v-icon small color="light-green lighten-2">fas fa-circle</v-icon>- Confermato
          </span>
          <span class="ml-2">
            <v-icon small color="red lighten-2">fas fa-circle</v-icon>- Annullato
          </span>
          <span class="ml-2">
            <v-icon small color="yellow darken-2">fas fa-circle</v-icon>- In attesa
          </span>
          <span class="ml-2">
            <v-icon small color="blue darken-3">fas fa-circle</v-icon>- Spesa aziendale
          </span>
        </v-toolbar-items>
      </v-toolbar>
      <v-container fluid grid-list-md>
        <div class="text-xs-center pt-2" v-if="pages > 0">
          <v-pagination v-model="pagination.page" :length="pages" color="secondary"></v-pagination>
        </div>
        <v-data-iterator
          hide-actions
          :items="items"
          :pagination.sync="pagination"
          content-tag="v-layout"
          row
          wrap
        >
          <v-flex
            slot="no-data"
            align-self-center
            class="title font-weight-light grey--text pa-3 text-xs-center"
          >Nessuna spesa da verificare!</v-flex>
          <VerificaNoteCard
            slot="item"
            slot-scope="props"
            :item="props.item"
            :key="props.item.identify"
            @on-click-verifica="showDettaglioSpesa"
            @on-click-invia="inviaSpesa"
          ></VerificaNoteCard>
        </v-data-iterator>
        <div class="text-xs-center pt-2" v-if="pages > 0">
          <v-pagination v-model="pagination.page" :length="pages" color="secondary"></v-pagination>
        </div>
      </v-container>
    </v-card>
    <v-bottom-sheet
      max-width="500px"
      v-if="spesaDettaglio"
      class="spesa-dettaglio"
      lazy
      inset
      persistent
      v-model="spesaDettaglioModale"
    >
      <v-toolbar color="secondary" class="spesa-dettaglio__toolbar">
        <v-toolbar-title
          class="primarytext--text"
        >{{$moment(spesaDettaglio.data, 'YYYY-MM-DD').format('dddd, Do MMMM YYYY')}}</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn icon @click="spesaDettaglioModale = false">
          <v-icon color="white">close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-list one-line subheader class="dettaglio-list">
        <el-scrollbar wrap-class="container__wrap" view-class="scroll__container">
          <v-flex v-if="spesaDettaglioAziendale.length > 0">
            <v-subheader inset class="tree--text">Spese anticipate dall'azienda</v-subheader>
          </v-flex>
          <template v-for="(spA, indA) in spesaDettaglioAziendale">
            <VerificaNoteDettaglioItem
              :key="indA"
              :item="spA"
              :res_prod="spesaDettaglio.res_prod !== null ? spesaDettaglio.res_prod : {}"
              :ore="spesaDettaglio.ore"
              @on-confirm="confirmNota"
            ></VerificaNoteDettaglioItem>
          </template>
          <v-flex
            v-if="spesaDettaglioDipendente.length > 0"
            style="justify-content: space-between; display: flex;"
          >
            <v-subheader class="tree--text">Spese anticipate dal dipendente</v-subheader>
            <v-subheader v-if="spesaDettaglio.res_prod !== null" class="tree--text">
              <v-flex>
                <div>Ore lavorate del mese: {{Number(spesaDettaglio.res_prod['ore']).toFixed(2)}}</div>
                <div>Aggiornate al {{spesaDettaglio.res_prod['max_date']}}</div>
              </v-flex>
            </v-subheader>
          </v-flex>
          <v-divider></v-divider>
          <template v-for="(spD, indD) in spesaDettaglioDipendente">
            <VerificaNoteDettaglioItem
              :item="spD"
              :key="indD"
              :res_prod="spesaDettaglio.res_prod !== null ? spesaDettaglio.res_prod : {}"
              @on-confirm="confirmNota"
            ></VerificaNoteDettaglioItem>
            <v-divider style="width: 90%" class="my-2 mx-4"></v-divider>
          </template>
        </el-scrollbar>
      </v-list>
    </v-bottom-sheet>
  </v-flex>
</template>

<script>
import VerificaNoteCard from "./VerificaNoteCard.vue";
import VerificaNoteDettaglioItem from "./VerificaNoteDettaglioItem.vue";

export default {
  name: "acc-verifica-note",
  components: {
    VerificaNoteCard,
    VerificaNoteDettaglioItem
  },
  props: {
    isGM: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    spesaDettaglioModale: false,
    protocolloAnteprimaModale: false,
    protocolloData: null,
    pagination: {
      rowsPerPage: 4
    },
    filter: "TUTTI"
  }),
  computed: {
    items() {
      return this.$store.getters["gestione/note"];
    },
    spesaDettaglio() {
      return this.$store.getters["gestione/spesaDettaglio"];
    },
    spesaDettaglioAziendale() {
      if (!this.spesaDettaglio.items) return [];
      return this.spesaDettaglio.items.filter(sp =>
        Boolean(+sp.is_anticipata_azienda)
      );
    },
    spesaDettaglioDipendente() {
      if (!this.spesaDettaglio.items) return [];
      return this.spesaDettaglio.items.filter(
        sp => !Boolean(+sp.is_anticipata_azienda)
      );
    },
    pages() {
      return Math.ceil(this.items.length / this.pagination.rowsPerPage);
    }
  },
  methods: {
    importoTotaleForDate(items) {
      return items
        .filter(itm => +itm.stato === 1)
        .map(itm => +itm.importo)
        .reduce((prev, next) => prev + next, 0);
    },
    importoTotaleForUser(spese) {
      let total = 0;

      spese.forEach(sp => {
        total += sp.items
          .filter(itm => +itm.stato === 1)
          .map(itm => +itm.importo)
          .reduce((prev, next) => prev + next, 0);
      });

      return total;
    },
    showDettaglioSpesa(login, spesa_id, data) {
      let $that = this;
      this.$store.commit("gestione/SET_SPESA_DETTAGLIO", []);
      this.$store
        .dispatch("gestione/getDettaglioSpesa", {
          login,
          spesa_id,
          data
        })
        .then(r => {
          $that.spesaDettaglioModale = true;
        });

      this.loginSelected = login;
      this.dataSelected = data;
    },
    confirmNota(nota, stato, motivo) {
      this.$store
        .dispatch("gestione/confirmNota", {
          nota: nota.id,
          stato: stato,
          motivo: motivo
        })
        .then(r =>
          this.$store.dispatch("gestione/getDettaglioSpesa", {
            login: this.loginSelected,
            data: this.dataSelected
          })
        );
    },
    inviaSpesa(spesa_id, type) {
      let $that = this;
      this.$store.dispatch("gestione/inviaSpesa", {
        spesa_id,
        type
      });
    }
  }
};
</script>

<style lang="scss">
.spesa-item {
  .v-list__tile {
    height: auto !important;
    .v-list__tile__sub-title {
      white-space: normal;
    }
  }
  .spesa-verify__btn {
    display: none;
  }
  &:hover {
    cursor: pointer;
    .spesa-verify__btn {
      display: flex;
    }
  }
}
.dettaglio-list .v-list__tile {
  height: auto !important;
}
.scroll__container {
  height: 70vh;
}
.spesa-dettaglio {
  .container__wrap {
    height: 50vh;
  }
  .spesa-dettaglio__toolbar {
    .v-toolbar__content {
      justify-content: center;
    }
  }
}
</style>



// WEBPACK FOOTER //
// modules/Home/views/src/components/TabVerificaNote.vue